//@flow
import * as React from 'react'
import ActionConfirmDialog from '../../components/ActionConfirmDialog';
import type { ContainerRowActionDialog$Props } from './flowTypes'

const ContainerRowActionDialog=(props:ContainerRowActionDialog$Props )=>{
    return (
        <div className="row">
            <div className="col-sm">
                <ActionConfirmDialog 
                    title={props.title}
                    message={props.message}
                    submitFunc={props.submitFunc}
                /> 
            </div>
        </div>  
    )
}

export default ContainerRowActionDialog


// WEBPACK FOOTER //
// ./src/components/common/ContainerRowActionDialog.js